// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-footer{padding:.5rem;position:absolute;right:0;bottom:0;left:0;text-align:center;max-height:60px;overflow-y:scroll}", ""]);
// Exports
module.exports = exports;
